"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const AccessData_1 = __importDefault(require("@becrop/components/Profile/Access/class/models/AccessData"));
const ModalAccess_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/ModalAccess.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const BulkActionsService_1 = __importDefault(require("../class/services/BulkActionsService"));
const ViewZero_vue_1 = __importDefault(require("../components/ViewZero.vue"));
let ModalIndividualGrantAccess = class ModalIndividualGrantAccess extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.checkContainer = [];
        this.isCheckedGlobal = false;
        this.norepeat = [];
        this.bulkService = new BulkActionsService_1.default();
    }
    async bulkAction() {
        if (this.dimension === 'samples') {
            await this.bulkService.accessSamples([this.sampleId], this.checkContainer, true);
        }
        else {
            await this.bulkService.accessProjects([this.projectId], this.checkContainer, true);
        }
    }
    actionCompleted() {
        this.dismissModal();
        this.$emit('recall');
    }
    get isBulkActionLoading() {
        return this.bulkService.isLoadingBulkAction;
    }
    get isBulkActionCompleted() {
        this.checkContainer = [];
        this.$emit('selectsDistributors', []);
        return this.bulkService.actionCompleted;
    }
    dismissModal() {
        this.$emit('dismissModal');
    }
    distributorsFilterByAccess(sampleId, projectId, filter) {
        if (this.dimension === 'samples') {
            return this.dataSet.filterDistributorsByAccessSample(sampleId, filter);
        }
        else {
            return this.dataSet.filterDistributorsByAccessProject(projectId, filter);
        }
    }
    isDistributorSelected(id) {
        return this.isCheckedGlobal || this.checkContainer.includes(id);
    }
    changeIsDistributorSelected(newValue, distributorId) {
        this.pushFn(distributorId);
    }
    changeIsCheckedGlobal(newValue) {
        this.isCheckedGlobal = newValue;
    }
    pushFn(id) {
        if (this.isCheckedGlobal) {
            this.isCheckedGlobal = false;
            this.checkContainer = [];
        }
        if (this.checkContainer.includes(id)) {
            this.checkContainer = this.checkContainer.filter((item) => item !== id);
        }
        else {
            this.checkContainer.push(id);
        }
        let notRepeat = [];
        notRepeat = this.checkContainer.filter((item, index) => {
            return this.checkContainer.indexOf(item) === index;
        });
        this.norepeat = notRepeat;
        this.$emit('selectsDistributors', notRepeat);
    }
    checkedGlobalObserver() {
        if (this.isCheckedGlobal) {
            this.checkContainer = [];
            for (const distributor of this.dimension === 'samples'
                ? this.distributorsFilterByAccess(this.sampleId, 0, 'without access')
                : this.distributorsFilterByAccess(0, this.projectId, 'without access')) {
                this.checkContainer.push(distributor.id);
            }
        }
        else {
            this.checkContainer = [];
        }
        let notRepeat = [];
        notRepeat = this.checkContainer.filter((item, index) => {
            return this.checkContainer.indexOf(item) === index;
        });
        this.$emit('selectsDistributors', notRepeat);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new AccessData_1.default() })
], ModalIndividualGrantAccess.prototype, "dataSet", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ModalIndividualGrantAccess.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], ModalIndividualGrantAccess.prototype, "sampleId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], ModalIndividualGrantAccess.prototype, "projectId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('isCheckedGlobal')
], ModalIndividualGrantAccess.prototype, "checkedGlobalObserver", null);
ModalIndividualGrantAccess = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            ModalAccess: ModalAccess_vue_1.default,
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBody: bmk_ui_framework_1.TableBody,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            CheckBox: bmk_ui_framework_1.CheckBox,
            CodeSnippet: bmk_ui_framework_1.CodeSnippet,
            Tag: bmk_ui_framework_1.Tag,
            Loader: bmk_ui_framework_1.Loader,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
            ViewZero: ViewZero_vue_1.default,
            WarningRoundedIcon: bmk_ui_framework_1.WarningRoundedIcon,
        },
    })
], ModalIndividualGrantAccess);
exports.default = ModalIndividualGrantAccess;
